import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, CreditCard } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function OfferSection() {
  return <section id="oferta" className="py-24 px-4 bg-gradient-to-b from-[#111827] to-[#0a0e1a] relative" data-id="element-82">
      <div className="max-w-4xl mx-auto text-center" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#1a1f2e] rounded-3xl p-8 md:p-12 border border-[#00d4ff]/30 box-glow-cyan relative overflow-hidden" data-id="element-84">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#00d4ff]/10 via-transparent to-transparent pointer-events-none" data-id="element-85" />

          <div className="relative z-10" data-id="element-86">
            <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-6" data-id="element-87">
              Tu Biología No Espera
            </h2>

            <p className="text-lg md:text-xl text-slate-300 mb-8" data-id="element-88">
              Recuperar tu identidad masculina no debería costar una fortuna en
              clínicas de reemplazo hormonal de{' '}
              <span className="line-through text-slate-500" data-id="element-89">$1,000 al mes</span>
              .
            </p>

            <div className="mb-10" data-id="element-90">
              <p className="text-slate-400 uppercase tracking-widest text-sm font-bold mb-4" data-id="element-91">
                Acceso Completo Hoy Por
              </p>

              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-92">
                <span className="text-3xl md:text-4xl font-black text-slate-500 line-through decoration-red-500 decoration-2" data-id="element-93">
                  $27
                </span>
                <span className="text-slate-500 line-through text-lg" data-id="element-94">USD</span>
              </div>

              <div className="inline-block bg-gradient-to-r from-amber-500 to-orange-600 text-white text-xs md:text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-95">
                🔥 Precio de Lanzamiento
              </div>

              <div className="flex items-center justify-center gap-4" data-id="element-96">
                <span className="text-6xl md:text-7xl font-black text-white" data-id="element-97">
                  $6.49
                </span>
                <div className="text-left" data-id="element-98">
                  <span className="block text-2xl font-bold text-[#00d4ff]" data-id="element-99">
                    USD
                  </span>
                  <span className="block text-sm text-slate-400 uppercase tracking-wider" data-id="element-100">
                    Pago Único
                  </span>
                </div>
              </div>

              <p className="text-green-400 font-bold text-sm mt-3 uppercase tracking-wide" data-id="element-101">
                Ahorras $20.51 — 76% de descuento
              </p>
            </div>

            <div className="max-w-md mx-auto mb-8" data-id="element-102">
              <CTAButton className="w-full text-lg md:text-xl py-5" href="https://thevigorlab.com/cart/54049731674484:1" data-id="element-103">
                ¡Quiero recuperar mi vigor ahora!
              </CTAButton>
            </div>

            {/* Trust Signals */}
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-slate-400 font-medium" data-id="element-104">
              <div className="flex items-center gap-2" data-id="element-105">
                <Zap className="w-5 h-5 text-amber-500" data-id="element-106" />
                <span data-id="element-107">Acceso inmediato</span>
              </div>
              <div className="hidden md:block w-1 h-1 rounded-full bg-slate-600" data-id="element-108" />
              <div className="flex items-center gap-2" data-id="element-109">
                <Lock className="w-5 h-5 text-green-500" data-id="element-110" />
                <span data-id="element-111">Pago 100% seguro</span>
              </div>
              <div className="hidden md:block w-1 h-1 rounded-full bg-slate-600" data-id="element-112" />
              <div className="flex items-center gap-2" data-id="element-113">
                <CreditCard className="w-5 h-5 text-[#00d4ff]" data-id="element-114" />
                <span data-id="element-115">Facturación discreta</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}